import { useEffect, useState } from "react";
import { fetchUserDetails } from "../apis/user.api";

// Roles allowed to view + book + cancel Delhivery bookings. Strict ROLE check
// (permission_name), not the "admin" permission — which the role matrix also
// grants to "tech". Admin and the delivery team get full Delhivery access.
export const DELHIVERY_ROLES = ["admin", "delivery", "delivery_team", "procurement"];

export const canManageDelhivery = (role: string | null | undefined): boolean =>
  !!role && DELHIVERY_ROLES.includes(role);

// Returns undefined until the role resolves, so callers can avoid flashing
// Delhivery UI before we know. Falls back to the cached user_role.
export const useCanManageDelhivery = (): boolean | undefined => {
  const [allowed, setAllowed] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;
    fetchUserDetails()
      .then((res) => {
        if (cancelled) return;
        const role =
          res?.branch?.user_permission?.permission_name ??
          localStorage.getItem("user_role");
        setAllowed(canManageDelhivery(role));
      })
      .catch(() => {
        if (!cancelled)
          setAllowed(canManageDelhivery(localStorage.getItem("user_role")));
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return allowed;
};

export default useCanManageDelhivery;
